import { render, staticRenderFns } from "./InscripcionEvento.vue?vue&type=template&id=0b04e4e6&scoped=true&"
import script from "./InscripcionEvento.vue?vue&type=script&lang=js&"
export * from "./InscripcionEvento.vue?vue&type=script&lang=js&"
import style0 from "./InscripcionEvento.vue?vue&type=style&index=0&id=0b04e4e6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04e4e6",
  null
  
)

export default component.exports